module.exports = __webpack_public_path__ + "static/devices-cc431fcfaed69a8df9944196933682c5.png";